import React from "react";
// import "./Rerender.scss";

interface RerenderProps {
  children: (rerender: () => void) => JSX.Element;
}
const Rerender = (props: RerenderProps) => {
  const [count, setCount] = React.useState(0);
  const rerender = () => {
    setCount((prev) => prev + 1);
  };

  return <>{props.children(rerender)}</>;
};

export default Rerender;
